import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Icon from 'components/atoms/Icon';

const useStyles = makeStyles((theme) => ({
  tableHeadRow: {
    '& > th:first-child': {
      zIndex: theme.zIndex.table.headFirst,
      borderRight: '1px solid #efefef',
    },
  },
  tableHeadCell: {
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: theme.zIndex.table.head,
    flexDirection: 'row',
    padding: '10px 16px',
    backgroundColor: theme.palette.table.headCellBg,
    borderTop: '1px solid rgba(224,224,224,1)',
    color: theme.palette.table.text,
    cursor: 'pointer',
    wordBreak: 'keep-all',
  },
  orderIco: {
    '& svg': {
      opacity: 0.4,
    },
    '&:hover svg': {
      opacity: 1,
    },
  },
  sortIcon: {
    marginLeft: 8,
    transition: 'all ease 0.4s',
    '&.active svg': {
      color: theme.palette.table.text,
      opacity: 1,
    },
    '&.asc': {
      transform: 'rotate(180deg)',
    },
    '&.desc': {
      transform: 'rotate(0deg)',
    },
  },
}));

const EnhancedTableHead = (props) => {
  const {
    onCheckboxAllClick,
    order,
    sort,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    hasCheckbox,
    tableKey = null,
    customized = {},
  } = props;

  const classes = useStyles();
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  /**
   * 헤드컬럼생성함수
   * @type {function(): []}
   */
  const makeHeadCell = useCallback(() => {
    const result = [];
    for (let headCell of headCells.values()) {
      const {
        id,
        disablePadding,
        // orderFlag,
        label,
        className,
        // align,
      } = headCell;

      let { orderFlag } = headCell;
      if (id !== 'SEQ') {
        let content = label;
        if (typeof customized[id] !== 'undefined') {
          if (customized[id].merged === true) {
            continue;
          } else if (typeof customized[id].makeHead !== 'undefined') {
            const result = customized[id].makeHead(headCells, tableKey);
            if (result.content !== undefined) {
              content = result.content;
              orderFlag = result.orderFlag;
            } else {
              content = result;
            }
          }
        }
        result.push(
          <TableCell
            style={
              customized[id] !== undefined ? customized[id].headStyle : null
            }
            className={className}
            classes={{ root: classes.tableHeadCell }}
            key={id}
            align="center"
            padding={disablePadding ? 'none' : 'default'}
            sortDirection={sort === id ? sort : false}
          >
            {orderFlag === true ? (
              <TableSortLabel
                className={classes.orderIco}
                active={order === id}
                direction={sort}
                onClick={createSortHandler(id)}
                IconComponent={() => {
                  return (
                    <div
                      className={clsx(classes.sortIcon, {
                        active: order === id,
                        desc: sort === 'desc',
                        asc: sort === 'asc',
                      })}
                    >
                      <Icon icon={'faCaretDown'} color={'default'} />
                    </div>
                  );
                }}
              >
                {content}
              </TableSortLabel>
            ) : (
              <>{content}</>
            )}
          </TableCell>
        );
      }
    }
    return result;
    // eslint-disable-next-line
  }, [
    headCells,
    customized,
    sort,
    order,
    onRequestSort,
    tableKey,
    createSortHandler,
    classes.sortIcon,
    classes.tableHeadCell,
    classes.orderIco,
  ]);

  return (
    <TableHead>
      <TableRow className={classes.tableHeadRow}>
        {hasCheckbox ? (
          <TableCell
            padding="checkbox"
            classes={{ root: classes.tableHeadCell }}
          >
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={!!numSelected && numSelected === rowCount}
              onChange={onCheckboxAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
              color="primary"
            />
          </TableCell>
        ) : null}
        {makeHeadCell()}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  //sort: PropTypes.oneOf(['asc', 'desc']).isRequired,
  //  order: PropTypes.string.isRequired,
};

export default React.memo(withRouter(EnhancedTableHead));
